export default __webpack_public_path__ + "static/media/start-filled-rounded.c700b47a.svg";